module.exports = __webpack_public_path__ + "static/img/faq.9d33407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/faq.png
// module id = AXP+
// module chunks = 36